import React, { Component } from 'react';
import Scrollbox from './Scrollbox';
import ObjectsListing from './ObjectsListing';
import spinner from '../images/spinner.gif';

class SearchResult extends Component {

    constructor(){
        super();

        this.state={
            scrolledTo: 0
        }

        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleShowRoom = this.handleShowRoom.bind(this);
        this.handleShowCart = this.handleShowCart.bind(this);
        this.handleScrollTo = this.handleScrollTo.bind(this);
    }

    handleAddToCart(cartItem){
        this.props.onAddToCart(cartItem);
    }

    handleShowRoom(item){
        this.props.onShowRoom(item);
    }

    handleShowCart(){        
        this.props.onShowCart();
    }

    handleScrollTo(position){
        this.setState({scrolledTo:position});
    }

    render(){ 
        if(this.props.visible){
            if(this.props.isSearching){
                let resultsHeight = 640;
                if(this.props.isMobile !== undefined && this.props.isMobile === true){
                    resultsHeight = window.innerHeight - 100;
                }
                return (
                    <div className="loading" style={{ height: resultsHeight }}>
                        <img src={spinner} alt="loading..." />
                    </div>
                )
            }else{  
                let resultsHeight = 640;
                if(this.props.isMobile !== undefined && this.props.isMobile === true){
                    resultsHeight = window.innerHeight - 130;
                }
                return(
                    
                        <Scrollbox style={{ height: resultsHeight }} scrolledTo={this.state.scrolledTo} id="listingScroll">                      
                            <ObjectsListing  
                                    items={this.props.foundObjects} 
                                    searchReason={this.props.searchReason}
                                    numPersons={this.props.numPersons}
                                    breakfast={this.props.breakfast}
                                    doublebed={this.props.doublebed}
                                    kitchen={this.props.kitchen}
                                    placeforkids={this.props.placeforkids}
                                    petsallowed={this.props.petsallowed}
                                    promocode={this.props.promocode}
                                    dateInterval={this.props.dateInterval}
                                    onAddToCart={this.handleAddToCart}
                                    onShowRoom={this.handleShowRoom}
                                    onShowCart={this.handleShowCart} 
                                    onScrollTo={this.handleScrollTo}
                                    isMobile = {this.props.isMobile}
                            />   
                        </Scrollbox>
                    
                )
            }
        }else{
            return false;
        } 
    }
    
}

export default SearchResult;